import React from 'react';

const PedidoEstoque: React.FC = () => {
  return <div />;
};
export default PedidoEstoque;
